import type { FaireProductEntity } from "../../entity_types/product";

export const p_895sp9cq8e: FaireProductEntity = {
  token: "p_895sp9cq8e",
  type: "product",
  name: "Basil Marinara Pasta Sauce",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/13ab5776bc2436cb2f42ad932818e99a9c0c6b627435fee7f6cd582f7a5c2999.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eecf5154d8425ad90e4154a8283df566d6684524922727f3be568cdb15328d2b.jpeg",
    "https://cdn.faire.com/fastly/c9f985a90e9a0d6b04d2cc75465d1ed9e69bd3e1395919ca5aaae32aefad2c44.jpeg",
    "https://cdn.faire.com/fastly/c5974d2063dd1534cd8c499dc0dfe86d629b42c02d66667362938356ed02e198.jpeg",
    "https://cdn.faire.com/fastly/cc8480c61fa2488b53d56bd1125b6a15b06a25a713f023a43cbd56d66f48ebed.jpeg",
    "https://cdn.faire.com/fastly/b81a39f231c40ba5b4e6bea311d84ee7988e87db122ed979ce0b4cac8c263243.jpeg"
  ],
  priceDollars: 6.48,
  description: "Made with 100% organic Corleonese heirloom tomatoes, our authentic Sicilian Marinara Pasta Sauce with Basil is infused with freshly picked basil leaves from La Furtuna Estate. This simple-yet-flavorful tomato basil sauce is great with pasta or as an addition to stews and ratatouilles.\n",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:20.464Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
